import React from 'react';
import PropTypes from 'prop-types';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import ScenarioChart from 'Components/ComponentLibrary/Organisms/ScenarioChart';
import useMobileLayout from 'Hooks/useMobileLayout';

const GradientSection = ({
  header, facetPlanClientViewResource, isMultiChart, flex, height,
}) => {
  const isMobile = useMobileLayout();
  const defaultHeight = isMobile ? 200 : 400;
  return (
    <VerticalStack flex={flex}>
      <StackItem hidden={!header} contentWidth={'lg'}>
        {header}
      </StackItem>
      <StackItem
        paddingHorizontal={2}
      >
        <ScenarioChart
          height={height ?? defaultHeight}
          resource={facetPlanClientViewResource}
          isMultiChart={isMultiChart}
        />
      </StackItem>
    </VerticalStack>
  );
};

GradientSection.defaultProps = {
  header: null,
  isMultiChart: true,
};

GradientSection.propTypes = {
  header: PropTypes.object,
  facetPlanClientViewResource: PropTypes.object.isRequired,
  isMultiChart: PropTypes.bool,
};

export default GradientSection;
